export const withUnderScore = (str: string) => {
  return str.replaceAll(' ', '_');
};
